import React, { useState } from 'react';
import { Package, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigation } from '../context/NavigationContext';
import { useApp } from '../context/AppContext';
import { Screen } from '../types';
import { Header } from '../components/ui/Header';
import { Button } from '../components/ui/Button';
export function OrdersScreen() {
  const {
    navigate
  } = useNavigation();
  const {
    orders
  } = useApp();
  const [activeTab, setActiveTab] = useState('Active');
  const tabs = ['Active', 'Completed', 'Cancelled'];
  const filteredOrders = orders.filter(order => {
    if (activeTab === 'Active') return ['Processing', 'Shipped'].includes(order.status);
    return order.status === activeTab;
  });
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="min-h-screen bg-gray-50 pb-24" data-id="element-911">
      <Header title="My Orders" showBack={false} data-id="element-912" />

      <div className="bg-white px-4 border-b border-gray-100 sticky top-[53px] z-30" data-id="element-913">
        <div className="flex justify-between" data-id="element-914">
          {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`py-3 px-2 text-sm font-medium border-b-2 transition-colors ${activeTab === tab ? 'border-primary text-primary' : 'border-transparent text-gray-500'}`} data-id="element-915">
              {tab}
            </button>)}
        </div>
      </div>

      <div className="p-4 space-y-4" data-id="element-916">
        {filteredOrders.length > 0 ? filteredOrders.map(order => <div key={order.id} className="bg-white rounded-2xl shadow-sm border border-gray-50 p-4" data-id="element-917">
              <div className="flex justify-between items-center mb-3 pb-3 border-b border-gray-50" data-id="element-918">
                <div data-id="element-919">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-920">{order.id}</p>
                  <p className="text-xs text-gray-500" data-id="element-921">
                    {new Date(order.date).toLocaleDateString()}
                  </p>
                </div>
                <span className={`px-2.5 py-1 rounded-md text-xs font-bold ${order.status === 'Processing' ? 'bg-warning/10 text-warning' : order.status === 'Shipped' ? 'bg-primary-100 text-primary-600' : order.status === 'Delivered' ? 'bg-success/10 text-success' : 'bg-error/10 text-error'}`} data-id="element-922">
                  {order.status}
                </span>
              </div>

              <div className="flex items-center gap-3 mb-4" data-id="element-923">
                <div className="flex -space-x-2" data-id="element-924">
                  {order.items.slice(0, 3).map((item, idx) => <div key={idx} className="w-12 h-12 rounded-lg border-2 border-white overflow-hidden bg-gray-100 shrink-0" data-id="element-925">
                      <img src={item.product.image} alt="" className="w-full h-full object-cover" data-id="element-926" />
                    </div>)}
                  {order.items.length > 3 && <div className="w-12 h-12 rounded-lg border-2 border-white bg-gray-100 flex items-center justify-center text-xs font-medium text-gray-600" data-id="element-927">
                      +{order.items.length - 3}
                    </div>}
                </div>
                <div className="flex-1" data-id="element-928">
                  <p className="text-sm text-gray-900 font-medium" data-id="element-929">
                    {order.items.length} items
                  </p>
                  <p className="text-primary font-bold" data-id="element-930">
                    ₦{order.total.toLocaleString()}
                  </p>
                </div>
              </div>

              <div className="flex gap-3" data-id="element-931">
                <Button variant="outline" size="sm" className="flex-1" onClick={() => navigate(Screen.ORDER_DETAIL, {
            orderId: order.id
          })} data-id="element-932">
                  Details
                </Button>
                {activeTab === 'Active' ? <Button size="sm" className="flex-1" onClick={() => navigate(Screen.ORDER_TRACKING, {
            orderId: order.id
          })} data-id="element-933">
                    Track Order
                  </Button> : <Button size="sm" className="flex-1" data-id="element-934">
                    Reorder
                  </Button>}
              </div>
            </div>) : <div className="py-12 flex flex-col items-center justify-center text-center" data-id="element-935">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4 text-gray-400" data-id="element-936">
              <Package className="w-8 h-8" data-id="element-937" />
            </div>
            <p className="text-gray-900 font-medium mb-1" data-id="element-938">
              No {activeTab} Orders
            </p>
            <p className="text-sm text-gray-500" data-id="element-939">
              You don't have any orders in this status.
            </p>
          </div>}
      </div>
    </motion.div>;
}